<mat-form-field
  class="admin__internal-info w-100"
  [class.admin__internal-info--yellow]="
    subProject.internalInfo != null && subProject.internalInfo.length > 0
  "
  appearance="outline"
>
  <mat-label>Nuttige info intern</mat-label>
  <textarea
    matInput
    [(ngModel)]="subProject.internalInfo"
    (ngModelChange)="save.emit(subProject)"
    cdkTextareaAutosize
  ></textarea>
</mat-form-field>
<div class="recurring-internal-info-container">
  <mat-checkbox
    [(ngModel)]="subProject.recurringInternalInfo"
    (ngModelChange)="save.emit(subProject)"
    >Toon bij elke volgende actie bovenvermelde info</mat-checkbox
  >
</div>
